import api from './api';

export const searchParcel = async (parcelCode, date) => {
  const { data } = await api.get(`/parcel/${parcelCode}`, { date });

  return data;
};
